import { MgBalanced } from '@montugroup/icons';
import MdNightlightRound from '@mui/icons-material/NightlightRound';
import MdWbSunny from '@mui/icons-material/WbSunny';
import { ProductStrainKeys } from '../../types';
const ProductStrainsMap = {
    [ProductStrainKeys.SATIVA]: {
        icon: MdWbSunny,
        color: '#FFA726',
        bgColor: '#FFF3E0',
    },
    [ProductStrainKeys.INDICA]: {
        icon: MdNightlightRound,
        color: '#4DB6AC',
        bgColor: '#E0F2F1',
    },
    [ProductStrainKeys.HYBRID]: {
        icon: MgBalanced,
        color: '#555555',
        bgColor: '#F5F5F5',
    },
};
export default ProductStrainsMap;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZHVjdFN0cmFpbnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29uc3RhbnRzL3Byb2R1Y3RzL3Byb2R1Y3RTdHJhaW5zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUMvQyxPQUFPLGlCQUFpQixNQUFNLHFDQUFxQyxDQUFDO0FBQ3BFLE9BQU8sU0FBUyxNQUFNLDZCQUE2QixDQUFDO0FBSXBELE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLGFBQWEsQ0FBQztBQVFoRCxNQUFNLGlCQUFpQixHQUE2QztJQUNsRSxDQUFDLGlCQUFpQixDQUFDLE1BQU0sQ0FBQyxFQUFFO1FBQzFCLElBQUksRUFBRSxTQUFTO1FBQ2YsS0FBSyxFQUFFLFNBQVM7UUFDaEIsT0FBTyxFQUFFLFNBQVM7S0FDbkI7SUFDRCxDQUFDLGlCQUFpQixDQUFDLE1BQU0sQ0FBQyxFQUFFO1FBQzFCLElBQUksRUFBRSxpQkFBaUI7UUFDdkIsS0FBSyxFQUFFLFNBQVM7UUFDaEIsT0FBTyxFQUFFLFNBQVM7S0FDbkI7SUFDRCxDQUFDLGlCQUFpQixDQUFDLE1BQU0sQ0FBQyxFQUFFO1FBQzFCLElBQUksRUFBRSxVQUFVO1FBQ2hCLEtBQUssRUFBRSxTQUFTO1FBQ2hCLE9BQU8sRUFBRSxTQUFTO0tBQ25CO0NBQ08sQ0FBQztBQUVYLGVBQWUsaUJBQWlCLENBQUMifQ==